import fetchShowroomApi from "../utils/fetch-showroom-api";

customElements.component = 'showroom-join';

if (!customElements.get(customElements.component)) {
  const selectors = {
    html: "html",
    form: ".js-join-form",
    cancelModal: ".js-cancel-modal",
    cancelModalTrigger: ".js-cancel-modal-trigger",
    modal: ".js-modal",
    modalInner: ".js-modal-inner",
    modalClose: ".js-modal-close",
  }

  class ShowroomJoin extends HTMLElement {
    constructor() {
      super();

      this.html = document.querySelector(selectors.html);
      this.form = this.querySelector(selectors.form);
      this.cancelModal = this.querySelector(selectors.cancelModal);
      this.cancelModalTrigger = this.querySelector(selectors.cancelModalTrigger);
      this.modalClose = this.querySelectorAll(selectors.modalClose);

      this.init();
    }

    openModal(el) {
      this.html.classList.add("overflow-hidden");
      el.classList.add("opened");
    }

    closeModal(el) {
      this.html.classList.remove("overflow-hidden");
      el.classList.remove("opened");
    }

    handleModalCloseOutside(e, modal) {
      const modalInner = modal.querySelector(selectors.modalInner);

      if (!modalInner.contains(e.target)) {
        this.closeModal(modal);
      }
    }

    async handleSubmitForm(e) {
      e.preventDefault();

      const formData = new FormData(this.form);

      const showroomID = formData.get("id");
      const payload = {
        name: formData.get("name"),
        email: formData.get("email")
      }

      await fetchShowroomApi(`/showrooms/${showroomID}/join`, "POST", JSON.stringify(payload));

      window.location = `/pages/showroom-event?id=${showroomID}`;
    }

    init() {
      this.form && this.form.addEventListener("submit", e => this.handleSubmitForm(e));

      if (this.cancelModal) {
        this.cancelModalTrigger && this.cancelModalTrigger.addEventListener("click", () => this.openModal(this.cancelModal));
        this.cancelModal.addEventListener("click", e => this.handleModalCloseOutside(e, this.cancelModal));

        this.modalClose && this.modalClose.forEach(el => el.addEventListener("click", () => this.closeModal(el.closest(selectors.modal))))
      }
    }
  }

  customElements.define(customElements.component, ShowroomJoin);
}
